import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { DisabledModule } from 'Angular/features/directives/disabled/disabled.module';
import { IconModule } from 'Angular/features/directives/icon/icon.module';

import { ModalBaseComponent } from './components/modal-base.component';
import { SimpleModalFooterComponent } from './components/simple-modal-footer.component';
import { SimpleModalHeaderComponent } from './components/simple-modal-header.component';

@NgModule({
    imports: [CommonModule, DisabledModule, IconModule, FormsModule],
    declarations: [ModalBaseComponent, SimpleModalFooterComponent, SimpleModalHeaderComponent],
    exports: [ModalBaseComponent, SimpleModalFooterComponent, SimpleModalHeaderComponent],
})
export class ModalBaseModule {}
